import { OnChangeProps } from '@/models/typings/ReactDateRange';
import { initialDateRange, SelectionType } from '@/pages/Data/Reports/ReportCard';
import { resolveLocale } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import moment from 'moment';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DateRange } from 'react-date-range';
import { useSelector } from 'react-redux';
import './style.scss';

interface SelectedRangeType {
    selection: SelectionType;
}

interface Props {
    show: boolean;
    close: () => void;
    selectedDateRange: SelectionType;
    setSelectedDateRange: CallableFunction;
    confirmAction: () => void;
}

const DateRangeModal: React.FC<Props> = ({ show, close, selectedDateRange, setSelectedDateRange, confirmAction }: Props) => {
    const { locale, strings, colors } = useSelector((state: ApplicationState) => {
        return {
            locale: state.locale.data._LANGUAGE,
            strings: state.locale.data,
            colors: state.appOrganization.data.colors,
        };
    });

    const isValidDateRange = () => {
        const { startDate, endDate } = selectedDateRange;

        return (
            startDate &&
            endDate &&
            endDate <= new Date() &&
            endDate <=
                moment(startDate)
                    .add(1, 'year')
                    .toDate()
        );
    };

    const handleSelectDate = (range: OnChangeProps) => {
        setSelectedDateRange((range as SelectedRangeType).selection);
    };

    return (
        <Modal backdrop="static" centered id="report-date-range-modal" onHide={close} show={show}>
            <Modal.Header closeButton>
                <Modal.Title>{strings.DATA_PAGE.DEFINE_THE_DATA_PERIOD}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DateRange
                    dateDisplayFormat="P"
                    editableDateInputs={true}
                    endDatePlaceholder={strings.DATA_PAGE.END_DATE}
                    locale={resolveLocale(locale)}
                    maxDate={new Date()}
                    minDate={new Date(2010, 1, 1)}
                    moveRangeOnFirstSelection={false}
                    onChange={handleSelectDate}
                    rangeColors={[colors[0]]}
                    ranges={[selectedDateRange]}
                    startDatePlaceholder={strings.DATA_PAGE.START_DATE}
                    weekdayDisplayFormat="EEEEEE"
                />
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-clear" onClick={() => setSelectedDateRange(initialDateRange)}>
                    {strings.CLEAR}
                </Button>
                <Button className="btn-generate" disabled={!isValidDateRange()} onClick={confirmAction}>
                    {strings.DATA_PAGE.CONFIRM}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DateRangeModal;
